import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer-dark">
      <div className="footer-content">
        <div className="footer-top">
          <div className="footer-brand">
            <img src="/logo.jpg" alt="Infinity Capital Inc." className="footer-logo-image" />
            <p className="footer-tagline">Invest in Tomorrow, Today.</p>
            <p className="footer-description">
              Strategic investment solutions delivering exceptional returns across diverse asset classes since 2010.
            </p>
          </div>

          <div className="footer-links-section">
            <div className="footer-column">
              <h4 className="footer-column-title">Services</h4>
              <ul className="footer-links">
                <li><button onClick={() => scrollToSection('services')} className="footer-link">Stock Market Investment</button></li>
                <li><button onClick={() => scrollToSection('services')} className="footer-link">Real Estate Investment</button></li>
                <li><button onClick={() => scrollToSection('services')} className="footer-link">Technology Startups</button></li>
                <li><button onClick={() => scrollToSection('services')} className="footer-link">Tax Strategy Planning</button></li>
                <li><button onClick={() => scrollToSection('services')} className="footer-link">Heavy Equipment Lease</button></li>
                <li><button onClick={() => scrollToSection('services')} className="footer-link">Oil & Gas Exploration</button></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">Company</h4>
              <ul className="footer-links">
                <li><button onClick={() => scrollToSection('about')} className="footer-link">About Us</button></li>
                <li><button onClick={() => scrollToSection('testimonials')} className="footer-link">Testimonials</button></li>
                <li><button onClick={() => scrollToSection('faq')} className="footer-link">FAQ</button></li>
                <li><button onClick={() => scrollToSection('contact')} className="footer-link">Contact</button></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">Contact</h4>
              <ul className="footer-contact">
                <li className="footer-contact-item">
                  <Phone size={16} />
                  <span>+1 (949) 694-1009</span>
                </li>
                <li className="footer-contact-item">
                  <Mail size={16} />
                  <span>invest@infinitycapitalinc.com</span>
                </li>
                <li className="footer-contact-item">
                  <MapPin size={16} />
                  <span>Newport Beach, CA 92660</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <p className="footer-copyright">
              © {currentYear} Infinity Capital Inc. All rights reserved.
            </p>
            <div className="footer-legal-links">
              <button className="footer-legal-link">Privacy Policy</button>
              <span className="footer-divider">|</span>
              <button className="footer-legal-link">Terms of Service</button>
              <span className="footer-divider">|</span>
              <button className="footer-legal-link">Disclaimer</button>
            </div>
          </div>
          <p className="footer-disclaimer">
            Investment involves risk. Past performance does not guarantee future results. Please consult with a financial advisor.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
